module.exports = __webpack_public_path__ + "media/reskin-images/icon--bin-bca8953e.svg";